import { styled } from "@mui/material/styles";

const CardMain = styled("div")(({ theme }) => ({
  maxWidth: "700px",
  margin: "auto",
  paddingTop: "70px",
  paddingBottom: "40px",
  // [theme.breakpoints.down("sm")]: {
  //   paddingBottom: "80px",
  //   paddingTop: "70px",
  //   maxWidth: "100%",
  //   width: "100%",
  // },
  [theme.breakpoints.down("md")]: {
    paddingBottom: "80px",
    paddingTop: "40px",
    maxWidth: "100%",
    width: "100%",
  },
}));
const Header = styled("div")(({ theme }) => ({ display: "flex", gap: "20px" }));
const LinkedButton = styled("button")(({ theme }) => ({
  height: "50px",
  border: "none",
  background: "transparent",
  cursor: "pointer",
}));

const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "10px",
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "40px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.6)",
    "& span": {
      color: "#0B0B0B !important",
      paddingLeft: "12px",
      fontWeight: 600,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: "20px",
    },
  },
}));

const CardFromMain = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
  "& form": {
    width: "50%",
  },
  "& .card_layout": {
    width: "50%",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column-reverse",
    "& form": {
      width: "100%",
    },
    "& .card_layout": {
      width: "100%",
    },
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column-reverse",
    "& form": {
      width: "100%",
    },
    "& .card_layout": {
      width: "100%",
    },
  },
  "& span": {
    color: "red",
  },
}));
const CardDateMain = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "15px",
  "& .AuthInputMain:first-child": {
    width: "50%",
  },
  "& .AuthInputMain:last-child": {
    width: "50%",
  },
}));
const CustomLabel = styled("label")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "25px",
  color: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,

  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    lineHeight: "22px",
  },
}));

const CustomInput = styled("input")(({ theme }) => ({
  width: "100%",
  height: "48px",
  background: "#F2F2F2",
  borderRadius: "10px",
  border: `1px solid transparent`,
  fontFamily: theme.typography.fontFamily,
  padding: "10px",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "25px",
  color: "rgba(11, 11, 11, 0.6)",
  "&:focus": {
    outline: "none",
    borderColor: theme.palette.primary.main,
  },
  "::placeholder": {
    color: "rgba(11, 11, 11, 0.6)",
  },
  marginBottom: "10px",
}));

export {
  CardMain,
  Header,
  LinkedButton,
  Maincontant,
  CardFromMain,
  CardDateMain,
  CustomLabel,
  CustomInput,
};
